export interface SelectOption {
	label: string;
	value: string;
}
